// styles/postBody.js
export const postBodyStyles = {
  color: "text.primary",
  fontSize: "0.938rem",
  lineHeight: 1.4,
  wordBreak: "break-word",

  /* generic descendants */
  "& *": { maxWidth: "100%", boxSizing: "border-box" },
  "& img": { maxWidth: "100%", height: "auto", borderRadius: 2, my: 1 },
  "& a": {
    color: "primary.main",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  },

  /* code / pre */
  "& pre": {
    backgroundColor: "background.paper",
    p: 1,
    borderRadius: 1,
    overflow: "auto",
    my: 1,
  },
  "& code": {
    backgroundColor: "background.paper",
    px: 0.5,
    borderRadius: 1,
    fontSize: "0.875em",
  },

  /* blockquote */
  "& blockquote": {
    borderLeft: "4px solid",
    borderColor: "divider",
    my: 1,
    pl: 1,
    fontSize: "1.1em",
  },

  /* lists */
  "& ul, & ol": { my: 1, pl: 3 },
  "& li": { my: 0.5 },

  /* headings + misc inline */
  "& h1": { fontSize: "2em", my: "0.67em" },
  "& h2": { fontSize: "1.5em", my: "0.75em" },
  "& h3": { fontSize: "1.17em", my: "0.83em" },
  "& h4": { fontSize: "1em", my: "1.12em" },
  "& small": { fontSize: "0.83em" },
  "& sup,& sub": { fontSize: "0.83em", lineHeight: 0, position: "relative" },
  "& sup": { top: "-0.5em" },
  "& sub": { bottom: "-0.25em" },
  "& mark": { backgroundColor: "yellow", color: "black", px: 0.25 },
};
